import { apiGet, apiPost } from './api';
import { BalancePoint, Holding, Trade, TradeResult } from '../types/portfolio';

export async function fetchBalances(userId: string): Promise<BalancePoint[]> {
  return apiGet<BalancePoint[]>(`/users/${userId}/balances`);
}

export async function fetchHoldings(userId: string): Promise<Holding[]> {
  return apiGet<Holding[]>(`/users/${userId}/holdings`);
}

export async function executeTrade(trade: Trade): Promise<TradeResult> {
  return apiPost<TradeResult>('/blockchain/execute-trade', trade);
}
